// extracted by mini-css-extract-plugin
module.exports = {"bttn":"bttn___2xIkG","content":"content___HpbC3","block":"block___3q5ZF","primary":"primary___1FrY4"};